<template>
	<v-form @keydown.enter.prevent>
		<v-container v-if="isEdit">
			<v-layout row wrap>
				<v-flex xs12 md6>
					<v-select ref="defaultFocusElement" v-model="value.prefix" :items="prefixes">
						<template slot="label">Prefix</template>
					</v-select>
				</v-flex>
				<v-flex xs12 md6>
					<v-menu ref="dateOfBirthMenu" v-model="value.dateOfBirth.menu" :close-on-content-click="false" :nudge-right="40" :return-value.sync="value.dateOfBirth.date" lazy transition="scale-transition" offset-y full-width min-width="290px">
						<v-text-field slot="activator" v-model="dateOfBirthFormatted" label="Date of Birth" readonly></v-text-field>
						<v-date-picker v-model="value.dateOfBirth.date" @input="$refs.dateOfBirthMenu.save(value.dateOfBirth.date)"></v-date-picker>
					</v-menu>
				</v-flex>
				<v-flex xs12 md6
					><v-select v-model="value.nationality" :items="nationalities">
						<template slot="label">Nationality</template>
					</v-select></v-flex
				>
				<v-flex xs12 md6
					><v-select v-model="value.gender" :items="genders">
						<template slot="label">Gender</template>
					</v-select></v-flex
				>
				<v-flex xs12 md6>
					<v-text-field v-model.trim="value.email" :error-messages="emailErrors" required>
						<template slot="label">Personal Email</template>
					</v-text-field>
				</v-flex>
				<v-flex xs12 md6>
					<v-text-field v-model.trim="value.phone">
						<template slot="label">Personal Phone</template>
					</v-text-field>
				</v-flex>
			</v-layout>
		</v-container>
		<v-container v-else>
			<v-layout row wrap>
				<v-flex xs12 md6>
					<div class="form-group">
						<span class="form-label">Prefix</span>
						<span class="form-value">{{ $_getFormValue('prefix') }}</span>
					</div>
				</v-flex>
				<v-flex xs12 md6>
					<div class="form-group">
						<span class="form-label">Date of Birth</span>
						<span class="form-value">{{ value.dateOfBirth.date == null ? '-' : dateOfBirthFormatted }}</span>
					</div>
				</v-flex>
				<v-flex xs12 md6
					><div class="form-group">
						<span class="form-label">Nationality</span>
						<span class="form-value">{{ $_getFormValue('nationality') }}</span>
					</div></v-flex
				>
				<v-flex xs12 md6
					><div class="form-group">
						<span class="form-label">Gender</span>
						<span class="form-value">{{ $_getFormValue('gender') }}</span>
					</div></v-flex
				>
				<v-flex xs12 md6
					><div class="form-group">
						<span class="form-label">Personal Email</span>
						<span class="form-value">{{ $_getFormValue('email') }}</span>
					</div></v-flex
				>
				<v-flex xs12 md6
					><div class="form-group">
						<span class="form-label">Personal Phone</span>
						<span class="form-value">{{ $_getFormValue('phone') }}</span>
					</div></v-flex
				>
			</v-layout>
		</v-container>
	</v-form>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { email } from 'vuelidate/lib/validators';
	import formMixin from '@/mixins/employeeFormMixin';

	export default {
		mixins: [validationMixin, formMixin],
		validations: {
			value: {
				prefix: {},
				nationality: {},
				dateOfBirth: { date: {} },
				email: { email },
				gender: {},
				phone: {}
			}
		},
		computed: {
			dateOfBirthFormatted() {
				return this.$options.filters.formatDate(this.value.dateOfBirth.date);
			},
			prefixes() {
				return ['Mr', 'Mrs', 'Ms', 'Miss', 'Mx', 'Dr', 'Prof', 'Rev'];
			},
			genders() {
				return [
					'Male',
					'Female',	
					'Non-binary',
					'Other',
					'Prefer not to disclose'
				]
			},
			emailErrors() {
				const errors = [];
				if (!this.$v.value.email.$dirty) return errors;
				!this.$v.value.email.email && errors.push('Must be valid e-mail');
				return errors;
			},
			nationalities() {
				return [
					'Afghan',
					'Albanian',
					'Algerian',
					'American',
					'Andorran',
					'Angolan',
					'Antiguans',
					'Argentine',
					'Armenian',
					'Australian',
					'Austrian',
					'Azerbaijani',
					'Bahamian',
					'Bahraini',
					'Bangladeshi',
					'Barbadian',
					'Belarusian',
					'Belgian',
					'Belizean',
					'Beninese',
					'Bhutanese',
					'Bolivian',
					'Bosnian',
					'Brazilian',
					'British',
					'Bruneian',
					'Bulgarian',
					'Burkinabe',
					'Burmese',
					'Burundian',
					'Cambodian',
					'Cameroonian',
					'Canadian',
					'Cape Verdean',
					'Central African',
					'Chadian',
					'Chilean',
					'Chinese',
					'Colombian',
					'Comoran',
					'Congolese',
					'Costa Rican',
					'Croatian',
					'Cuban',
					'Cypriot',
					'Czech',
					'Danish',
					'Djiboutian',
					'Dominican',
					'Dutch',
					'East Timorese',
					'Ecuadorean',
					'Egyptian',
					'Emirati',
					'English',
					'Equatorial Guinean',
					'Eritrean',
					'Estonian',
					'Ethiopian',
					'Fijian',
					'Filipino',
					'Finnish',
					'French',
					'Gabonese',
					'Gambian',
					'Georgian',
					'German',
					'Ghanaian',
					'Greek',
					'Grenadian',
					'Guatemalan',
					'Guinea-Bissauan',
					'Guinean',
					'Guyanese',
					'Haitian',
					'Honduran',
					'Hungarian',
					'Icelander',
					'Indian',
					'Indonesian',
					'Iranian',
					'Iraqi',
					'Irish',
					'Israeli',
					'Italian',
					'Ivorian',
					'Jamaican',
					'Japanese',
					'Jordanian',
					'Kazakhstani',
					'Kenyan',
					'Kittian and Nevisian',
					'Kuwaiti',
					'Kyrgyz',
					'Laotian',
					'Latvian',
					'Lebanese',
					'Liberian',
					'Libyan',
					'Liechtensteiner',
					'Lithuanian',
					'Luxembourger',
					'Macedonian',
					'Malagasy',
					'Malawian',
					'Malaysian',
					'Maldivian',
					'Malian',
					'Maltese',
					'Marshallese',
					'Mauritanian',
					'Mauritian',
					'Mexican',
					'Micronesian',
					'Moldovan',
					'Monacan',
					'Mongolian',
					'Montenegrin',
					'Moroccan',
					'Mosotho',
					'Motswana',
					'Mozambican',
					'Namibian',
					'Nauruan',
					'Nepalese',
					'New Zealander',
					'Nicaraguan',
					'Nigerian',
					'Nigerien',
					'North Korean',
					'Northern Irish',
					'Norwegian',
					'Omani',
					'Pakistani',
					'Palauan',
					'Palestinian',
					'Panamanian',
					'Papua New Guinean',
					'Paraguayan',
					'Peruvian',
					'Polish',
					'Portuguese',
					'Qatari',
					'Romanian',
					'Russian',
					'Rwandan',
					'Saint Lucian',
					'Salvadoran',
					'Samoan',
					'San Marinese',
					'Sao Tomean',
					'Saudi',
					'Scottish',
					'Senegalese',
					'Serbian',
					'Seychellois',
					'Sierra Leonean',
					'Singaporean',
					'Slovakian',
					'Slovenian',
					'Solomon Islander',
					'Somali',
					'South African',
					'South Korean',
					'Spanish',
					'Sri Lankan',
					'Sudanese',
					'Surinamer',
					'Swazi',
					'Swedish',
					'Swiss',
					'Syrian',
					'Taiwanese',
					'Tajik',
					'Tanzanian',
					'Thai',
					'Togolese',
					'Tongan',
					'Trinidadian or Tobagonian',
					'Tunisian',
					'Turkish',
					'Tuvaluan',
					'Ugandan',
					'Ukrainian',
					'Uruguayan',
					'Uzbekistani',
					'Venezuelan',
					'Vietnamese',
					'Welsh',
					'Yemenite',
					'Zambian',
					'Zimbabwean'
				];
			}
		}
	};
</script>
